import { gql } from '@apollo/client'

export const qmrLeadTimeContributions = gql`
    query QmrLeadTimeContributions($quoteModelRevisionId: UUID!) {
        qmrLeadTimeContributions(quoteModelRevisionId: $quoteModelRevisionId) {
            fastestDomesticLeadTimeBreakdown {
                additionalDays {
                    longPart
                    tightTolerance
                    lathe
                    uncommonMaterials
                    reamer
                    pdfAutoQuotability
                    smallHoles
                    undercuts
                    smallTaps
                    machiningTimeBasedMinimumProductionDays
                }
            }
        }
    }
`

export const calculateQuoteModelRevisionPendingPricesBreakdownPercentages = gql`
    query CalculateQuoteModelRevisionPendingPricesBreakdownPercentages(
        $quoteModelRevisionId: UUID!
    ) {
        calculateQuoteModelRevisionPendingPricesBreakdownPercentages(
            quoteModelRevisionId: $quoteModelRevisionId
        ) {
            machineCost
            materialCost
            threadCost
            setupCost
            camCost
            fixtureCost
            miscNonRecurringEngineeringCost
            toleranceCost
            toolCost
            otherCost
        }
    }
`

export const CostAndLeadTime = gql`
    query CostAndLeadTime($quoteId: UUID!) {
        quote(id: $quoteId) {
            id
            name
            status
            type
            isQuotePurchasable
            reorderSourceOrderName
            user {
                id
            }
            quoteModels(limit: 1000) {
                totalCount
                items {
                    selectedQuoteModelRevision {
                        id
                        state
                        holes {
                            id
                            tapOptions {
                                id
                            }
                        }
                        taps {
                            id
                        }
                        attachmentLink {
                            id
                            quoteAttachmentRevision {
                                id
                                attachment {
                                    ... on Attachment {
                                        id
                                        fileName
                                        downloadUrl
                                        annotated {
                                            id
                                            fileName
                                            downloadUrl
                                        }
                                        sanitized {
                                            id
                                            fileName
                                            downloadUrl
                                        }
                                    }
                                }
                            }
                        }
                        dfmFeedback {
                            id
                            accepted
                            severity
                            message
                            isPublished
                        }
                        modelConfiguration {
                            id

                            productionLeadTime {
                                id
                                priorityId
                                productionDays
                            }
                            process {
                                id
                            }
                            material {
                                ... on Material {
                                    id
                                }
                                ... on UserEnteredMaterial {
                                    id
                                    process {
                                        id
                                    }
                                }
                            }
                            materialGrade
                            textureCode
                            colorCode
                            productionLeadTime {
                                priorityId
                            }
                            quantity
                        }
                        processesDetails {
                            primaryProcess {
                                price {
                                    ... on ExactPrice {
                                        priceInCents
                                    }
                                }

                                process {
                                    name
                                    id
                                }
                            }
                            productionLeadTime {
                                shipDateEstimate {
                                    shippedByDate
                                }
                            }
                            postProcesses {
                                unitPriceInCents
                                postProcess {
                                    name
                                    id
                                }
                                postProcessColor {
                                    id
                                    name
                                }
                                postProcessLeadTimeInDays
                                postProcessInspectionCriteria
                                postProcessNumParts
                                postProcessThickness {
                                    value
                                }
                            }
                            totalPrice {
                                ... on ExactPrice {
                                    priceInCents
                                }
                            }
                        }
                        fileName
                        partRevision {
                            thumbnailUri
                        }
                        version
                        quantityRangeStatus
                    }
                }
            }
        }
    }
`

export const queryForGetAllBatchPostProcessIds = gql`
    query Query {
        getAllBatchPostProcessIds
    }
`

export const getQlltSlackThreadQuery = gql`
    query GetQlltSlackThread($quoteId: String!) {
        getQlltSlackThread(quoteId: $quoteId) {
            url
        }
    }
`
export const getBusinessAccountFeatureQuery = gql`
    query GetBusinessAccountFeature(
        $businessAccountId: UUID!
        $featureName: BusinessAccountFeatureInput!
    ) {
        getBusinessAccountFeature(
            businessAccountId: $businessAccountId
            featureName: $featureName
        ) {
            id
            businessAccountId
            featureName
            isEnabled
            updatedAt
        }
    }
`
